export default __webpack_public_path__ + "static/media/Nose.9fd1666f.svg";